import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout'
import personalLayout from '@/components/personalLayout'
import store from '@/store'
import { getInfo } from '@/plugins/api'

Vue.use(VueRouter)

async function ensureAnswerUser(to, from, next) {
      if (!EUtils.getCookie('Authorization')) {
        next({ path: '/login', query: { redirect: to.fullPath } })
        return
      }
      if (!(store.getters.userInfo || {}).user_id) {
        let params = to.params || {}
        if (!Object.keys(params).length)
          try {
            params = JSON.parse(localStorage.getItem(to.name === 'pointsQuestion' ? 'pointsQuestion' : 'answerSheet') || '{}')
          } catch (_) {}
        let parent = params.identity_parent_id || params.identity_id
        if (!parent)
          try {
            const ids = EUtils.getIdentityPath()
            parent = ids[ids.length - 1]
          } catch (_) {}
        if (!parent) {
          next('/home')
          return
        }
        try {
          const result = await getInfo({ identity_id: parent, center: '1' })
          if (!result.data || !result.data.user_id) throw new Error('账号资料未能载入')
          await store.dispatch('app/setIdentityId', String(parent))
          store.commit('app/SET_USER_INFO', result.data)
          const name = EUtils.getCookie('identityName')
          if (name) store.commit('app/SET_IDENTITY_NAME', decodeURIComponent(name))
        } catch (_) {
          next(EUtils.getCookie('Authorization') ? '/home' : { path: '/login', query: { redirect: to.fullPath } })
          return
        }
      }
      next()
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: '/ai/question',
        name: 'questionAi',
        component: () => import(/* webpackChunkName: "study-ai" */ '../views/ai/QaWorkspace.vue')
      },
      {
        path: '/ai/general',
        name: 'generalAi',
        component: () => import(/* webpackChunkName: "study-ai" */ '../views/ai/QaWorkspace.vue')
      },
      {
        path: '/home',
        name: 'home',
        component: () => import(/* webpackChunkName: "study" */ '../views/study/Home.vue')
      },
      {
        path: '/study/plan',
        name: 'studyPlan',
        component: () => import(/* webpackChunkName: "study" */ '../views/study/LearningPlan.vue')
      },
      {
        path: '/study/plan/edit',
        name: 'studyPlanEdit',
        component: () => import(/* webpackChunkName: "study" */ '../views/study/PlanEditor.vue')
      },
      {
        path: '/study/plan/practice',
        name: 'studyPlanPractice',
        component: () => import(/* webpackChunkName: "study" */ '../views/study/PlanPractice.vue')
      },
      {
        path: '/study/practice',
        name: 'studyPractice',
        component: () => import(/* webpackChunkName: "study" */ '../views/study/ReportPractice.vue')
      },
      {
        path: '/study/report',
        name: 'studyReport',
        component: () => import(/* webpackChunkName: "study" */ '../views/study/StudyReport.vue')
      },
      {
        path: '/questions',
        name: 'questions',
        component: () => import(/* webpackChunkName: "about" */ '../views/questions.vue')
      },
      {
        path: '/humanDialogue',
        name: 'humanDialogue',
        component: () => import(/* webpackChunkName: "about" */ '../views/humanDialogue.vue')
      },
      {
        path: '/autonomous',
        name: 'autonomous',
        component: () => import(/* webpackChunkName: "about" */ '../views/autonomousPractice.vue')
      },
      {
        path: '/liveList',
        name: 'liveList',
        component: () =>
          import(/* webpackChunkName: "live-streaming" */ '../views/liveStreaming/liveList.vue')
      },
      {
        path: '/openMember',
        name: 'openMember',
        component: () => import(/* webpackChunkName: "about" */ '../views/openMember.vue')
      },
      {
        path: '/dailyPractice',
        name: 'dailyPractice',
        component: () => import(/* webpackChunkName: "about" */ '../views/dailyPractice.vue')
      },
      {
        path: '/square',
        name: 'square',
        component: () => import(/* webpackChunkName: "about" */ '../views/square.vue')
      },
      {
        path: '/forum',
        name: 'forum',
        component: () => import(/* webpackChunkName: "about" */ '../views/forum/index.vue')
      },
      {
        path: '/postDetails',
        name: 'postDetails',
        component: () => import(/* webpackChunkName: "about" */ '../views/forum/components/postDetails.vue')
      },
      // {
      //   path: '/shoppingMall',
      //   name: 'shoppingMall',
      //   component: () => import(/* webpackChunkName: "about" */ '../views/shoppingMall/index.vue')
      // },
      {
        path: '/shopDetail',
        name: 'shopDetail',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/shoppingMall/components/shopDetail.vue')
      },
      {
        path: '/publish',
        name: 'publish',
        component: () => import(/* webpackChunkName: "about" */ '../views/forum/components/publish.vue')
      },
      {
        path: '/points',
        name: 'points',
        component: () => import(/* webpackChunkName: "about" */ '../views/points/index.vue')
      },
      {
        path: '/pointsDetails',
        name: 'pointsDetails',
        component: () => import(/* webpackChunkName: "about" */ '../views/points/components/pointsDetals.vue')
      },
      {
        path: '/partTimeJob',
        name: 'partTimeJob',
        component: () => import('../views/partTimeJob/index.vue')
      },
      {
        path: '/medicalCode',
        name: 'medicalCode',
        component: () => import(/* webpackChunkName: "medical-code" */ '../views/medicalCode/index.vue')
      },
      {
        path: '/medicalCode/directory',
        name: 'medicalCodeDirectory',
        component: () => import(/* webpackChunkName: "medical-code" */ '../views/medicalCode/directory.vue')
      },
      {
        path: '/medicalCode/codes',
        name: 'medicalCodeCodes',
        component: () => import(/* webpackChunkName: "medical-code" */ '../views/medicalCode/codes.vue')
      },
      {
        path: '/medicalCode/detail',
        name: 'medicalCodeDetail',
        component: () => import(/* webpackChunkName: "medical-code" */ '../views/medicalCode/detail.vue')
      },
      {
        path: '/medicalCode/reverse',
        name: 'medicalCodeReverse',
        component: () => import(/* webpackChunkName: "medical-code" */ '../views/medicalCode/reverse.vue')
      },
      {
        path: '/medicalCode/reverse/detail',
        name: 'medicalCodeReverseDetail',
        component: () =>
          import(/* webpackChunkName: "medical-code" */ '../views/medicalCode/reverseDetail.vue')
      },
      {
        path: '/medicalCode/ai',
        name: 'medicalCodeAi',
        component: () => import(/* webpackChunkName: "medical-code" */ '../views/medicalCode/ai.vue')
      }
    ]
  },
  {
    path: '/personalCenter',
    component: personalLayout,
    children: [
      {
        path: '/personalCenter',
        name: 'personalCenter',
        component: () => import(/* webpackChunkName: "about" */ '../views/personalCenter/index.vue')
      },
      {
        path: '/followWith',
        name: 'followWith',
        component: () => import(/* webpackChunkName: "about" */ '../views/followWith/index.vue')
      },
      {
        path: '/myOrderList',
        name: 'myOrderList',
        component: () => import(/* webpackChunkName: "about" */ '../views/myOrderList/index.vue')
      },
      {
        path: '/mySlash',
        name: 'mySlash',
        component: () => import(/* webpackChunkName: "about" */ '../views/personalCenter/MySlash.vue')
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: () => import(/* webpackChunkName: "about" */ '../views/feedback/index.vue')
      },
      {
        path: '/address',
        name: 'address',
        component: () => import(/* webpackChunkName: "about" */ '../views/address/index.vue')
      },
      {
        path: '/paymentMethod',
        name: 'paymentMethod',
        component: () => import(/* webpackChunkName: "about" */ '../views/paymentMethod/index.vue')
      },
      {
        path: '/notice',
        name: 'notice',
        component: () => import(/* webpackChunkName: "about" */ '../views/notice/index.vue')
      },
      {
        path: '/service',
        name: 'service',
        component: () => import(/* webpackChunkName: "about" */ '../views/service/index.vue')
      },
      {
        path: '/myCoupons',
        name: 'myCoupons',
        component: () => import(/* webpackChunkName: "about" */ '../views/myCoupons/index.vue')
      },
      {
        path: '/myInvitation',
        name: 'myInvitation',
        component: () => import(/* webpackChunkName: "about" */ '../views/myInvitation/index.vue')
      },
      {
        path: '/commentOfMe',
        name: 'commentOfMe',
        component: () => import(/* webpackChunkName: "about" */ '../views/comment/commentOfMe.vue')
      },
      {
        path: '/myComment',
        name: 'myComment',
        component: () => import(/* webpackChunkName: "about" */ '../views/comment/myComment.vue')
      }
    ]
  },

  {
    path: '/liveStudent',
    name: 'liveStudent',
    component: () => import(/* webpackChunkName: "live-streaming" */ '../views/liveStreaming/liveStudent.vue')
  },
  {
    path: '/liveTeacher',
    name: 'liveTeacher',
    component: () => import(/* webpackChunkName: "about" */ '../views/liveStreaming/liveTeacher.vue')
  },
  {
    path: '/aiAsk',
    name: 'aiAsk',
    props: (route) => ({ params: route.params }),
    component: () => import(/* webpackChunkName: "about" */ '../views/aiAsk/index.vue')
  },
  {
    path: '/machineExam',
    name: 'machineExam',
    props: (route) => ({ params: route.params }),
    component: () => import(/* webpackChunkName: "about" */ '../views/machineExam/index.vue')
  },
  {
    path: '/answerSheet',
    name: 'answerSheet',
    beforeEnter: ensureAnswerUser,
    props: (route) => ({ params: route.params }),
    component: () => import(/* webpackChunkName: "about" */ '../views/answerSheet.vue')
  },
  {
    path: '/pointsQuestion',
    name: 'pointsQuestion',
    beforeEnter: ensureAnswerUser,
    props: (route) => ({ params: route.params }),
    component: () => import(/* webpackChunkName: "about" */ '../views/pointsQuestion.vue')
  },
  {
    path: '/searchQuestion',
    name: 'searchQuestion',
    component: () => import(/* webpackChunkName: "about" */ '../views/searchQuestion.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

export default router
